import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AccuracyNewRoutingModule } from './accuracy-new-routing.module';
import { AccuracyNewComponent } from './accuracy-new.component';
import { DxChartModule, DxTextAreaModule, DxRangeSelectorModule, DxDataGridModule, DxSwitchModule } from 'devextreme-angular';
import { DevEpressCommonModule } from 'src/app/dev-epress-common.module';
import { BookmarkModule } from 'src/app/widgets/bookmark/bookmark.module';
import { DxTableControllerDirective } from 'src/app/directives/dx-table-controller.directive';
import { WebExportModule } from 'src/app/widgets/web-export/web.export.module';


@NgModule({
  declarations: [AccuracyNewComponent],
  imports: [
    CommonModule,
    AccuracyNewRoutingModule,
    DxChartModule,
    DxTextAreaModule,
    DxRangeSelectorModule,
    DxDataGridModule,
    DevEpressCommonModule, BookmarkModule ,DxSwitchModule,
	DxTableControllerDirective, WebExportModule
  ]
})
export class AccuracyNewModule { }
